// AUTO-GENERATED by scripts/generate-catalog.mjs — DO NOT EDIT.
// Constellation metadata (88 IAU constellations) and line segments. Segments reference catalog star indices in data/stars.ts (negative indices are virtual vertices stored in constellationFallbackPoints).
// Data sources: IAU constellation list; line data derived from d3-celestial (BSD-3-Clause), snapped to HYG stars
// See src/catalog/data/attribution.ts for licenses and provenance.


export interface ConstellationMeta {
  id: string;
  name: string;
  english: string;
  segments: number;
  fallbackPoints: number;
}

export const CONSTELLATIONS: readonly ConstellationMeta[] = [
  {
    "id": "And",
    "name": "Andromeda",
    "english": "the Chained Maiden",
    "segments": 20,
    "fallbackPoints": 0
  },
  {
    "id": "Ant",
    "name": "Antlia",
    "english": "the Air Pump",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "Aps",
    "name": "Apus",
    "english": "the Bird of Paradise",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Aqr",
    "name": "Aquarius",
    "english": "the Water Bearer",
    "segments": 18,
    "fallbackPoints": 0
  },
  {
    "id": "Aql",
    "name": "Aquila",
    "english": "the Eagle",
    "segments": 9,
    "fallbackPoints": 0
  },
  {
    "id": "Ara",
    "name": "Ara",
    "english": "the Altar",
    "segments": 6,
    "fallbackPoints": 0
  },
  {
    "id": "Ari",
    "name": "Aries",
    "english": "the Ram",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Aur",
    "name": "Auriga",
    "english": "the Charioteer",
    "segments": 10,
    "fallbackPoints": 0
  },
  {
    "id": "Boo",
    "name": "Bootes",
    "english": "the Herdsman",
    "segments": 14,
    "fallbackPoints": 0
  },
  {
    "id": "Cae",
    "name": "Caelum",
    "english": "the Chisel",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Cam",
    "name": "Camelopardalis",
    "english": "the Giraffe",
    "segments": 8,
    "fallbackPoints": 0
  },
  {
    "id": "Cnc",
    "name": "Cancer",
    "english": "the Crab",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "CVn",
    "name": "Canes Venatici",
    "english": "the Hunting Dogs",
    "segments": 1,
    "fallbackPoints": 0
  },
  {
    "id": "CMa",
    "name": "Canis Major",
    "english": "the Great Dog",
    "segments": 13,
    "fallbackPoints": 0
  },
  {
    "id": "CMi",
    "name": "Canis Minor",
    "english": "the Lesser Dog",
    "segments": 1,
    "fallbackPoints": 0
  },
  {
    "id": "Cap",
    "name": "Capricornus",
    "english": "the Sea Goat",
    "segments": 10,
    "fallbackPoints": 0
  },
  {
    "id": "Car",
    "name": "Carina",
    "english": "the Keel",
    "segments": 19,
    "fallbackPoints": 0
  },
  {
    "id": "Cas",
    "name": "Cassiopeia",
    "english": "the Seated Queen",
    "segments": 4,
    "fallbackPoints": 0
  },
  {
    "id": "Cen",
    "name": "Centaurus",
    "english": "the Centaur",
    "segments": 18,
    "fallbackPoints": 0
  },
  {
    "id": "Cep",
    "name": "Cepheus",
    "english": "the King",
    "segments": 12,
    "fallbackPoints": 0
  },
  {
    "id": "Cet",
    "name": "Cetus",
    "english": "the Sea Monster",
    "segments": 15,
    "fallbackPoints": 0
  },
  {
    "id": "Cha",
    "name": "Chamaeleon",
    "english": "the Chameleon",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Cir",
    "name": "Circinus",
    "english": "the Compasses",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "Col",
    "name": "Columba",
    "english": "the Dove",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Com",
    "name": "Coma Berenices",
    "english": "the Hair of Berenice",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "CrA",
    "name": "Corona Australis",
    "english": "the Southern Crown",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "CrB",
    "name": "Corona Borealis",
    "english": "the Northern Crown",
    "segments": 6,
    "fallbackPoints": 0
  },
  {
    "id": "Crv",
    "name": "Corvus",
    "english": "the Crow",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Crt",
    "name": "Crater",
    "english": "the Cup",
    "segments": 10,
    "fallbackPoints": 0
  },
  {
    "id": "Cru",
    "name": "Crux",
    "english": "the Southern Cross",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Cyg",
    "name": "Cygnus",
    "english": "the Swan",
    "segments": 9,
    "fallbackPoints": 0
  },
  {
    "id": "Del",
    "name": "Delphinus",
    "english": "the Dolphin",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Dor",
    "name": "Dorado",
    "english": "the Dolphinfish",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "Dra",
    "name": "Draco",
    "english": "the Dragon",
    "segments": 17,
    "fallbackPoints": 0
  },
  {
    "id": "Equ",
    "name": "Equuleus",
    "english": "the Little Horse",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "Eri",
    "name": "Eridanus",
    "english": "the River",
    "segments": 26,
    "fallbackPoints": 0
  },
  {
    "id": "For",
    "name": "Fornax",
    "english": "the Furnace",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "Gem",
    "name": "Gemini",
    "english": "the Twins",
    "segments": 12,
    "fallbackPoints": 0
  },
  {
    "id": "Gru",
    "name": "Grus",
    "english": "the Crane",
    "segments": 9,
    "fallbackPoints": 0
  },
  {
    "id": "Her",
    "name": "Hercules",
    "english": "the Strongman",
    "segments": 21,
    "fallbackPoints": 0
  },
  {
    "id": "Hor",
    "name": "Horologium",
    "english": "the Clock",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Hya",
    "name": "Hydra",
    "english": "the Water Snake",
    "segments": 18,
    "fallbackPoints": 0
  },
  {
    "id": "Hyi",
    "name": "Hydrus",
    "english": "the Lesser Water Snake",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Ind",
    "name": "Indus",
    "english": "the Indian",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Lac",
    "name": "Lacerta",
    "english": "the Lizard",
    "segments": 11,
    "fallbackPoints": 0
  },
  {
    "id": "Leo",
    "name": "Leo",
    "english": "the Lion",
    "segments": 10,
    "fallbackPoints": 0
  },
  {
    "id": "LMi",
    "name": "Leo Minor",
    "english": "the Lesser Lion",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Lep",
    "name": "Lepus",
    "english": "the Hare",
    "segments": 11,
    "fallbackPoints": 0
  },
  {
    "id": "Lib",
    "name": "Libra",
    "english": "the Scales",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "Lup",
    "name": "Lupus",
    "english": "the Wolf",
    "segments": 13,
    "fallbackPoints": 0
  },
  {
    "id": "Lyn",
    "name": "Lynx",
    "english": "the Lynx",
    "segments": 6,
    "fallbackPoints": 0
  },
  {
    "id": "Lyr",
    "name": "Lyra",
    "english": "the Lyre",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "Men",
    "name": "Mensa",
    "english": "the Table Mountain",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Mic",
    "name": "Microscopium",
    "english": "the Microscope",
    "segments": 5,
    "fallbackPoints": 0
  },
  {
    "id": "Mon",
    "name": "Monoceros",
    "english": "the Unicorn",
    "segments": 9,
    "fallbackPoints": 0
  },
  {
    "id": "Mus",
    "name": "Musca",
    "english": "the Fly",
    "segments": 6,
    "fallbackPoints": 0
  },
  {
    "id": "Nor",
    "name": "Norma",
    "english": "the Carpenter's Square",
    "segments": 4,
    "fallbackPoints": 0
  },
  {
    "id": "Oct",
    "name": "Octans",
    "english": "the Octant",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Oph",
    "name": "Ophiuchus",
    "english": "the Serpent Bearer",
    "segments": 19,
    "fallbackPoints": 0
  },
  {
    "id": "Ori",
    "name": "Orion",
    "english": "the Hunter",
    "segments": 27,
    "fallbackPoints": 0
  },
  {
    "id": "Pav",
    "name": "Pavo",
    "english": "the Peacock",
    "segments": 10,
    "fallbackPoints": 0
  },
  {
    "id": "Peg",
    "name": "Pegasus",
    "english": "the Winged Horse",
    "segments": 15,
    "fallbackPoints": 0
  },
  {
    "id": "Per",
    "name": "Perseus",
    "english": "the Hero",
    "segments": 25,
    "fallbackPoints": 0
  },
  {
    "id": "Phe",
    "name": "Phoenix",
    "english": "the Phoenix",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "Pic",
    "name": "Pictor",
    "english": "the Painter's Easel",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "Psc",
    "name": "Pisces",
    "english": "the Fishes",
    "segments": 24,
    "fallbackPoints": 0
  },
  {
    "id": "PsA",
    "name": "Piscis Austrinus",
    "english": "the Southern Fish",
    "segments": 9,
    "fallbackPoints": 0
  },
  {
    "id": "Pup",
    "name": "Puppis",
    "english": "the Poop Deck",
    "segments": 12,
    "fallbackPoints": 0
  },
  {
    "id": "Pyx",
    "name": "Pyxis",
    "english": "the Mariner's Compass",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Ret",
    "name": "Reticulum",
    "english": "the Net",
    "segments": 4,
    "fallbackPoints": 0
  },
  {
    "id": "Sge",
    "name": "Sagitta",
    "english": "the Arrow",
    "segments": 4,
    "fallbackPoints": 0
  },
  {
    "id": "Sgr",
    "name": "Sagittarius",
    "english": "the Archer",
    "segments": 32,
    "fallbackPoints": 0
  },
  {
    "id": "Sco",
    "name": "Scorpius",
    "english": "the Scorpion",
    "segments": 14,
    "fallbackPoints": 0
  },
  {
    "id": "Scl",
    "name": "Sculptor",
    "english": "the Sculptor",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Sct",
    "name": "Scutum",
    "english": "the Shield",
    "segments": 4,
    "fallbackPoints": 0
  },
  {
    "id": "Ser",
    "name": "Serpens",
    "english": "the Serpent",
    "segments": 13,
    "fallbackPoints": 0
  },
  {
    "id": "Sex",
    "name": "Sextans",
    "english": "the Sextant",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Tau",
    "name": "Taurus",
    "english": "the Bull",
    "segments": 13,
    "fallbackPoints": 0
  },
  {
    "id": "Tel",
    "name": "Telescopium",
    "english": "the Telescope",
    "segments": 2,
    "fallbackPoints": 0
  },
  {
    "id": "Tri",
    "name": "Triangulum",
    "english": "the Triangle",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "TrA",
    "name": "Triangulum Australe",
    "english": "the Southern Triangle",
    "segments": 3,
    "fallbackPoints": 0
  },
  {
    "id": "Tuc",
    "name": "Tucana",
    "english": "the Toucan",
    "segments": 6,
    "fallbackPoints": 0
  },
  {
    "id": "UMa",
    "name": "Ursa Major",
    "english": "the Great Bear",
    "segments": 26,
    "fallbackPoints": 0
  },
  {
    "id": "UMi",
    "name": "Ursa Minor",
    "english": "the Lesser Bear",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "Vel",
    "name": "Vela",
    "english": "the Sails",
    "segments": 7,
    "fallbackPoints": 0
  },
  {
    "id": "Vir",
    "name": "Virgo",
    "english": "the Maiden",
    "segments": 14,
    "fallbackPoints": 0
  },
  {
    "id": "Vol",
    "name": "Volans",
    "english": "the Flying Fish",
    "segments": 6,
    "fallbackPoints": 0
  },
  {
    "id": "Vul",
    "name": "Vulpecula",
    "english": "the Little Fox",
    "segments": 4,
    "fallbackPoints": 0
  }
];

export const constellationLineSegments = new Int32Array([
  637, 359, 359, 197, 197, 50, 50, 296, 296, 242, 242, 194, 194, 197, 197, 187,
  187, 8766, 8766, 8568, 8568, 8766, 8766, 8777, 8777, 8760, 8760, 359, 359, 293, 293, 259,
  259, 358, 358, 497, 497, 8777, 8777, 8804, 3670, 4002, 4002, 4183, 5414, 5983, 5983, 6110,
  6110, 6056, 7774, 7809, 7809, 8038, 8038, 8228, 8228, 8333, 8333, 8370, 8370, 8406, 8406, 8509,
  8509, 8659, 8659, 8614, 8614, 8038, 8038, 8236, 8236, 8228, 8228, 8309, 8309, 8370, 8370, 8352,
  8352, 8693, 8693, 8659, 8659, 8783, 7347, 7379, 7379, 7418, 7418, 7528, 7528, 7397, 7397, 7212,
  7212, 7077, 7077, 7379, 7379, 7212, 7212, 7080, 6376, 6418, 6418, 6142, 6142, 6203, 6203, 6209,
  6209, 6427, 6427, 6375, 868, 649, 649, 580, 580, 574, 2093, 1739, 1739, 1673, 1673, 1609,
  1609, 1817, 1817, 2094, 2094, 2093, 2093, 2092, 2092, 1739, 1739, 1636, 1636, 1641, 5088, 5128,
  5128, 5233, 5233, 5328, 5328, 5329, 5329, 5496, 5496, 5574, 5574, 5391, 5391, 5233, 5233, 5372,
  5372, 5329, 5329, 5238, 5238, 5217, 5217, 5294, 5294, 5238, 1460, 1520, 1520, 1524, 1524, 1656,
  1611, 1649, 1649, 1587, 1587, 1224, 1224, 1216, 1216, 1079, 1079, 1587, 1587, 2240, 2240, 2573,
  3482, 3377, 3377, 3369, 3369, 3395, 3395, 3377, 3377, 3165, 4825, 4699, 2263, 2446, 2446, 2594,
  2594, 2635, 2635, 2585, 2585, 2561, 2561, 2250, 2250, 2753, 2753, 2635, 2635, 2446, 2446, 2540,
  2540, 2599, 2599, 2525, 2525, 2540, 2870, 2782, 7572, 7600, 7600, 7645, 7645, 7760, 7760, 7804,
  7804, 8013, 8013, 8137, 8137, 8088, 8088, 7982, 7982, 7887, 7887, 7572, 2392, 2275, 2275, 3567,
  3567, 3919, 3919, 4096, 4096, 4037, 4037, 3940, 3940, 3600, 3600, 3208, 3208, 3014, 3014, 3115,
  3115, 3378, 3378, 3600, 3600, 4096, 4096, 4236, 4236, 4244, 4244, 4265, 4265, 4245, 4245, 4160,
  4160, 4037, 579, 434, 434, 292, 292, 204, 204, 58, 4299, 4537, 4537, 4663, 4663, 4735,
  4735, 5041, 5041, 5133, 5133, 5097, 5097, 5096, 5096, 5188, 5188, 5346, 5346, 5481, 5481, 5096,
  5096, 4940, 4940, 5365, 5365, 5041, 5041, 5175, 5175, 4663, 4663, 4555, 4555, 4349, 7652, 7757,
  7757, 7960, 7960, 8112, 8112, 8298, 8298, 8269, 8269, 8374, 8374, 8493, 8493, 8770, 8770, 8024,
  8024, 7960, 7960, 8024, 8024, 8493, 831, 788, 788, 756, 756, 845, 845, 924, 924, 937,
  937, 831, 831, 810, 810, 714, 714, 564, 564, 533, 533, 219, 219, 109, 109, 355,
  355, 423, 423, 564, 3178, 4056, 4056, 4114, 4114, 4594, 4594, 4496, 4496, 4056, 5588, 5382,
  5382, 5630, 2260, 2029, 2029, 1948, 1948, 1860, 1860, 2029, 2029, 2090, 4882, 4889, 4889, 4654,
  7025, 7082, 7082, 7104, 7104, 7112, 7112, 7099, 7099, 7062, 7062, 6943, 6943, 6835, 5678, 5648,
  5648, 5688, 5688, 5744, 5744, 5779, 5779, 5835, 5835, 5859, 4539, 4546, 4546, 4580, 4580, 4671,
  4671, 4703, 4703, 4546, 4382, 4316, 4316, 4294, 4294, 4195, 4195, 4254, 4254, 4310, 4310, 4317,
  4317, 4428, 4428, 4481, 4481, 4294, 4294, 4317, 4771, 4574, 4574, 4651, 4651, 4682, 7921, 7762,
  7762, 7607, 7607, 7341, 7341, 7235, 7235, 7151, 7151, 7738, 7738, 7607, 7607, 7428, 7428, 7242,
  7672, 7698, 7698, 7720, 7720, 7767, 7767, 7750, 7750, 7698, 1348, 1479, 1479, 1881, 1881, 1982,
  1982, 2051, 2051, 1881, 1881, 1666, 1666, 1479, 6562, 6579, 6579, 6411, 6411, 6432, 6432, 6562,
  6562, 7121, 7121, 6735, 6735, 6270, 6270, 6001, 6001, 5860, 5860, 5638, 5638, 5179, 5179, 4695,
  4695, 4347, 4347, 6735, 6735, 6741, 6741, 7121, 7121, 7358, 7942, 7931, 7931, 7913, 1685, 1542,
  1542, 1492, 1492, 1321, 1321, 1258, 1258, 1190, 1190, 1161, 1161, 1112, 1112, 899, 899, 838,
  838, 847, 847, 939, 939, 1031, 1031, 1117, 1117, 1194, 1194, 1487, 1487, 1408, 1408, 1358,
  1358, 1215, 1215, 1133, 1133, 1033, 1033, 912, 912, 817, 817, 748, 748, 699, 699, 590,
  590, 493, 987, 862, 862, 639, 2204, 2265, 2265, 2437, 2437, 2648, 2648, 2837, 2837, 2924,
  2924, 2843, 2843, 2728, 2728, 2606, 2606, 2391, 2391, 2447, 2447, 2728, 2728, 2714, 8560, 8487,
  8487, 8453, 8453, 8377, 8377, 8243, 8243, 8453, 8453, 8375, 8375, 8300, 8300, 8233, 8233, 8167,
  5990, 6038, 6038, 6094, 6094, 6107, 6107, 6058, 6058, 5979, 5979, 5906, 5906, 5796, 5796, 6094,
  6094, 6214, 6214, 6107, 6107, 6296, 6296, 6575, 6575, 6360, 6360, 6296, 6296, 6214, 6214, 6295,
  6295, 6514, 6514, 6591, 6591, 6655, 6655, 6294, 6294, 6038, 1335, 827, 827, 799, 799, 816,
  816, 943, 943, 916, 3397, 3408, 3408, 3368, 3368, 3325, 3325, 3319, 3319, 3397, 3397, 3460,
  3460, 3578, 3578, 3748, 3748, 3658, 3658, 3808, 3808, 3898, 3898, 3997, 3997, 4142, 4142, 4360,
  4360, 4465, 4465, 4935, 4935, 5186, 5186, 5431, 130, 1195, 1195, 812, 812, 721, 721, 582,
  582, 606, 7699, 7751, 7751, 7824, 7824, 8187, 8187, 7968, 7968, 7699, 8343, 8388, 8388, 8376,
  8376, 8329, 8329, 8385, 8385, 8438, 8438, 8376, 8376, 8348, 8348, 8343, 8343, 8385, 8385, 8292,
  8292, 8301, 3888, 3880, 3880, 3960, 3960, 4274, 4274, 4448, 4448, 4275, 4275, 3888, 3888, 3960,
  3960, 3938, 3938, 3817, 3817, 3779, 3881, 3996, 3996, 4156, 4156, 4008, 4008, 3881, 3881, 3714,
  2142, 2071, 2071, 1994, 1994, 1874, 1874, 1711, 1711, 1665, 1665, 1838, 1838, 1980, 1980, 2032,
  2032, 1713, 1713, 1711, 1711, 1759, 5506, 5436, 5436, 5586, 5586, 5693, 5693, 5705, 5705, 5716,
  5716, 5436, 5436, 5693, 5786, 5726, 5726, 5616, 5616, 5614, 5614, 5476, 5476, 5377, 5377, 5551,
  5551, 5595, 5595, 5624, 5624, 5690, 5690, 5848, 5848, 5890, 5890, 5614, 5614, 5690, 2244, 2550,
  2550, 2778, 2778, 3213, 3213, 3495, 3495, 3612, 3612, 3624, 6903, 6901, 6901, 6856, 6856, 6903,
  6903, 6982, 6982, 7028, 7028, 6950, 6950, 6903, 2175, 1865, 1865, 1599, 1599, 1642, 7794, 7781,
  7781, 7972, 7972, 7954, 7954, 7859, 7859, 7794, 2889, 3104, 3104, 2655, 2655, 2324, 2324, 2203,
  2203, 2655, 2655, 2472, 2472, 2271, 2271, 2357, 2357, 2419, 4431, 4591, 4591, 4717, 4717, 4761,
  4761, 4847, 4847, 4690, 4690, 4717, 5889, 6017, 6017, 5980, 5980, 5868, 5868, 5889, 5304, 8472,
  8472, 8092, 8092, 5304, 6599, 6522, 6522, 6503, 6503, 6446, 6446, 6199, 6199, 6043, 6043, 5945,
  5945, 5973, 5973, 6072, 6072, 6276, 6276, 6199, 6199, 6072, 6072, 6045, 6045, 6016, 6016, 6003,
  6003, 6012, 6012, 6503, 6503, 6276, 6276, 6350, 6350, 6397, 2156, 2055, 2055, 2123, 2123, 2190,
  2190, 2112, 2112, 2065, 2065, 1811, 1811, 1594, 1594, 1617, 1617, 1588, 1588, 1572, 1572, 1563,
  1563, 1568, 1568, 1594, 1594, 1607, 1607, 1658, 1658, 1695, 1695, 1724, 1724, 1799, 1799, 1867,
  1867, 1811, 1811, 1896, 1896, 2065, 2065, 1955, 1955, 2008, 2008, 1955, 1955, 1912, 1912, 1867,
  7624, 7755, 7755, 7518, 7518, 6964, 6964, 6757, 6757, 6664, 6664, 6513, 6513, 6887, 6887, 7463,
  7463, 7755, 7755, 8010, 8256, 8456, 8456, 8578, 8578, 50, 50, 74, 74, 8584, 8584, 8476,
  8476, 8443, 8443, 8259, 8259, 8118, 8118, 8584, 8584, 8578, 8578, 8496, 8496, 8475, 8475, 8237,
  8237, 8122, 1167, 1239, 1239, 1263, 1263, 1257, 1257, 1178, 1178, 1160, 1160, 1129, 1129, 1056,
  1056, 948, 948, 874, 874, 894, 894, 969, 969, 971, 971, 965, 965, 981, 981, 949,
  949, 914, 914, 922, 922, 965, 965, 1293, 1293, 1342, 1342, 1304, 1304, 1160, 1160, 969,
  969, 840, 840, 530, 132, 336, 336, 449, 449, 460, 460, 353, 353, 336, 336, 61,
  61, 132, 2473, 2018, 2018, 2001, 383, 374, 374, 404, 404, 383, 383, 372, 372, 461,
  461, 539, 539, 620, 620, 575, 575, 512, 512, 456, 456, 382, 382, 320, 320, 251,
  251, 8867, 8867, 8775, 8775, 8718, 8718, 8678, 8678, 8653, 8653, 8709, 8709, 8786, 8786, 8805,
  8805, 8775, 8775, 8653, 8653, 8579, 8439, 8542, 8542, 8533, 8533, 8508, 8508, 8391, 8391, 8246,
  8246, 8124, 8124, 8142, 8142, 8246, 8246, 8439, 2392, 2706, 2706, 2841, 2841, 2866, 2866, 2959,
  2959, 3015, 3015, 3099, 3099, 3078, 3078, 3115, 3115, 2959, 2959, 2947, 2947, 2911, 2911, 2841,
  3078, 3340, 3340, 3370, 3370, 3421, 1337, 1350, 1350, 1261, 1261, 1166, 1166, 1337, 7304, 7352,
  7352, 7443, 7443, 7312, 7312, 7352, 6720, 6767, 6767, 6739, 6739, 6793, 6793, 6696, 6696, 7187,
  7187, 7195, 7195, 7058, 7058, 6915, 6915, 6793, 6793, 7417, 7417, 7452, 7452, 7422, 7422, 7280,
  7280, 7206, 7206, 7138, 7138, 6990, 6990, 6915, 6915, 6739, 6739, 6638, 6638, 6767, 6767, 7058,
  7058, 7089, 7089, 6990, 6990, 7071, 7071, 7107, 7107, 7153, 7153, 7180, 7180, 7181, 7181, 7071,
  7071, 7016, 7016, 6979, 6979, 6990, 5841, 5850, 5850, 5881, 5881, 5850, 5850, 5988, 5988, 6032,
  6032, 6063, 6063, 6144, 6144, 6155, 6155, 6174, 6174, 6283, 6283, 6463, 6463, 6519, 6519, 6495,
  6495, 6439, 305, 8819, 8819, 8665, 8665, 8740, 6843, 6929, 6929, 6882, 6882, 6799, 6799, 6843,
  5761, 5736, 5736, 5776, 5776, 5826, 5826, 5761, 5761, 5689, 5689, 5754, 5754, 5785, 5785, 5945,
  6276, 6467, 6467, 6599, 6599, 6626, 6626, 6743, 6743, 6997, 3884, 3816, 3816, 4016, 4016, 4023,
  1929, 1490, 1490, 1445, 1445, 1372, 1372, 1398, 1398, 1443, 1443, 1817, 1817, 1372, 1372, 1269,
  1269, 1068, 1068, 1277, 1277, 1068, 1068, 1061, 1061, 1132, 6685, 6785, 6785, 6798, 571, 659,
  659, 704, 704, 571, 6137, 5813, 5813, 5598, 5598, 6137, 8318, 8656, 8656, 158, 158, 111,
  111, 8870, 8870, 8362, 8362, 8318, 4577, 4222, 4222, 4212, 4212, 4468, 4468, 4577, 4577, 4810,
  4810, 4959, 4959, 5091, 5091, 4468, 4468, 4434, 4434, 4289, 4289, 8887, 8887, 4434, 4434, 4250,
  4250, 3974, 3974, 4250, 4250, 3941, 3941, 4222, 4222, 3684, 3684, 3266, 3266, 3801, 3801, 4212,
  4212, 3813, 3813, 3700, 3700, 3486, 3486, 3512, 3512, 3700, 5752, 5969, 5969, 5607, 5607, 5435,
  5435, 5752, 5752, 6126, 6126, 6430, 6430, 772, 3378, 3631, 3631, 3835, 3835, 4125, 4125, 3925,
  3925, 3680, 3680, 3529, 3529, 3115, 4433, 4456, 4456, 4604, 4604, 4738, 4738, 4881, 4881, 4966,
  4966, 5234, 5234, 5383, 5383, 4846, 4846, 4822, 4822, 4738, 4738, 4881, 4881, 5014, 5014, 5162,
  5162, 5405, 3507, 3234, 3234, 3101, 3101, 2703, 2703, 2638, 2638, 3101, 3101, 3507, 7143, 7227,
  7227, 7404, 7404, 7466, 7466, 7558,
]);

export interface ConstellationLines {
  [abbrev: string]: readonly (readonly [number, number])[];
}

export const CONSTELLATION_LINES: ConstellationLines = {"And":[[637,359],[359,197],[197,50],[50,296],[296,242],[242,194],[194,197],[197,187],[187,8766],[8766,8568],[8568,8766],[8766,8777],[8777,8760],[8760,359],[359,293],[293,259],[259,358],[358,497],[497,8777],[8777,8804]],"Ant":[[3670,4002],[4002,4183]],"Aps":[[5414,5983],[5983,6110],[6110,6056]],"Aqr":[[7774,7809],[7809,8038],[8038,8228],[8228,8333],[8333,8370],[8370,8406],[8406,8509],[8509,8659],[8659,8614],[8614,8038],[8038,8236],[8236,8228],[8228,8309],[8309,8370],[8370,8352],[8352,8693],[8693,8659],[8659,8783]],"Aql":[[7347,7379],[7379,7418],[7418,7528],[7528,7397],[7397,7212],[7212,7077],[7077,7379],[7379,7212],[7212,7080]],"Ara":[[6376,6418],[6418,6142],[6142,6203],[6203,6209],[6209,6427],[6427,6375]],"Ari":[[868,649],[649,580],[580,574]],"Aur":[[2093,1739],[1739,1673],[1673,1609],[1609,1817],[1817,2094],[2094,2093],[2093,2092],[2092,1739],[1739,1636],[1636,1641]],"Boo":[[5088,5128],[5128,5233],[5233,5328],[5328,5329],[5329,5496],[5496,5574],[5574,5391],[5391,5233],[5233,5372],[5372,5329],[5329,5238],[5238,5217],[5217,5294],[5294,5238]],"Cae":[[1460,1520],[1520,1524],[1524,1656]],"Cam":[[1611,1649],[1649,1587],[1587,1224],[1224,1216],[1216,1079],[1079,1587],[1587,2240],[2240,2573]],"Cnc":[[3482,3377],[3377,3369],[3369,3395],[3395,3377],[3377,3165]],"CVn":[[4825,4699]],"CMa":[[2263,2446],[2446,2594],[2594,2635],[2635,2585],[2585,2561],[2561,2250],[2250,2753],[2753,2635],[2635,2446],[2446,2540],[2540,2599],[2599,2525],[2525,2540]],"CMi":[[2870,2782]],"Cap":[[7572,7600],[7600,7645],[7645,7760],[7760,7804],[7804,8013],[8013,8137],[8137,8088],[8088,7982],[7982,7887],[7887,7572]],"Car":[[2392,2275],[2275,3567],[3567,3919],[3919,4096],[4096,4037],[4037,3940],[3940,3600],[3600,3208],[3208,3014],[3014,3115],[3115,3378],[3378,3600],[3600,4096],[4096,4236],[4236,4244],[4244,4265],[4265,4245],[4245,4160],[4160,4037]],"Cas":[[579,434],[434,292],[292,204],[204,58]],"Cen":[[4299,4537],[4537,4663],[4663,4735],[4735,5041],[5041,5133],[5133,5097],[5097,5096],[5096,5188],[5188,5346],[5346,5481],[5481,5096],[5096,4940],[4940,5365],[5365,5041],[5041,5175],[5175,4663],[4663,4555],[4555,4349]],"Cep":[[7652,7757],[7757,7960],[7960,8112],[8112,8298],[8298,8269],[8269,8374],[8374,8493],[8493,8770],[8770,8024],[8024,7960],[7960,8024],[8024,8493]],"Cet":[[831,788],[788,756],[756,845],[845,924],[924,937],[937,831],[831,810],[810,714],[714,564],[564,533],[533,219],[219,109],[109,355],[355,423],[423,564]],"Cha":[[3178,4056],[4056,4114],[4114,4594],[4594,4496],[4496,4056]],"Cir":[[5588,5382],[5382,5630]],"Col":[[2260,2029],[2029,1948],[1948,1860],[1860,2029],[2029,2090]],"Com":[[4882,4889],[4889,4654]],"CrA":[[7025,7082],[7082,7104],[7104,7112],[7112,7099],[7099,7062],[7062,6943],[6943,6835]],"CrB":[[5678,5648],[5648,5688],[5688,5744],[5744,5779],[5779,5835],[5835,5859]],"Crv":[[4539,4546],[4546,4580],[4580,4671],[4671,4703],[4703,4546]],"Crt":[[4382,4316],[4316,4294],[4294,4195],[4195,4254],[4254,4310],[4310,4317],[4317,4428],[4428,4481],[4481,4294],[4294,4317]],"Cru":[[4771,4574],[4574,4651],[4651,4682]],"Cyg":[[7921,7762],[7762,7607],[7607,7341],[7341,7235],[7235,7151],[7151,7738],[7738,7607],[7607,7428],[7428,7242]],"Del":[[7672,7698],[7698,7720],[7720,7767],[7767,7750],[7750,7698]],"Dor":[[1348,1479],[1479,1881],[1881,1982],[1982,2051],[2051,1881],[1881,1666],[1666,1479]],"Dra":[[6562,6579],[6579,6411],[6411,6432],[6432,6562],[6562,7121],[7121,6735],[6735,6270],[6270,6001],[6001,5860],[5860,5638],[5638,5179],[5179,4695],[4695,4347],[4347,6735],[6735,6741],[6741,7121],[7121,7358]],"Equ":[[7942,7931],[7931,7913]],"Eri":[[1685,1542],[1542,1492],[1492,1321],[1321,1258],[1258,1190],[1190,1161],[1161,1112],[1112,899],[899,838],[838,847],[847,939],[939,1031],[1031,1117],[1117,1194],[1194,1487],[1487,1408],[1408,1358],[1358,1215],[1215,1133],[1133,1033],[1033,912],[912,817],[817,748],[748,699],[699,590],[590,493]],"For":[[987,862],[862,639]],"Gem":[[2204,2265],[2265,2437],[2437,2648],[2648,2837],[2837,2924],[2924,2843],[2843,2728],[2728,2606],[2606,2391],[2391,2447],[2447,2728],[2728,2714]],"Gru":[[8560,8487],[8487,8453],[8453,8377],[8377,8243],[8243,8453],[8453,8375],[8375,8300],[8300,8233],[8233,8167]],"Her":[[5990,6038],[6038,6094],[6094,6107],[6107,6058],[6058,5979],[5979,5906],[5906,5796],[5796,6094],[6094,6214],[6214,6107],[6107,6296],[6296,6575],[6575,6360],[6360,6296],[6296,6214],[6214,6295],[6295,6514],[6514,6591],[6591,6655],[6655,6294],[6294,6038]],"Hor":[[1335,827],[827,799],[799,816],[816,943],[943,916]],"Hya":[[3397,3408],[3408,3368],[3368,3325],[3325,3319],[3319,3397],[3397,3460],[3460,3578],[3578,3748],[3748,3658],[3658,3808],[3808,3898],[3898,3997],[3997,4142],[4142,4360],[4360,4465],[4465,4935],[4935,5186],[5186,5431]],"Hyi":[[130,1195],[1195,812],[812,721],[721,582],[582,606]],"Ind":[[7699,7751],[7751,7824],[7824,8187],[8187,7968],[7968,7699]],"Lac":[[8343,8388],[8388,8376],[8376,8329],[8329,8385],[8385,8438],[8438,8376],[8376,8348],[8348,8343],[8343,8385],[8385,8292],[8292,8301]],"Leo":[[3888,3880],[3880,3960],[3960,4274],[4274,4448],[4448,4275],[4275,3888],[3888,3960],[3960,3938],[3938,3817],[3817,3779]],"LMi":[[3881,3996],[3996,4156],[4156,4008],[4008,3881],[3881,3714]],"Lep":[[2142,2071],[2071,1994],[1994,1874],[1874,1711],[1711,1665],[1665,1838],[1838,1980],[1980,2032],[2032,1713],[1713,1711],[1711,1759]],"Lib":[[5506,5436],[5436,5586],[5586,5693],[5693,5705],[5705,5716],[5716,5436],[5436,5693]],"Lup":[[5786,5726],[5726,5616],[5616,5614],[5614,5476],[5476,5377],[5377,5551],[5551,5595],[5595,5624],[5624,5690],[5690,5848],[5848,5890],[5890,5614],[5614,5690]],"Lyn":[[2244,2550],[2550,2778],[2778,3213],[3213,3495],[3495,3612],[3612,3624]],"Lyr":[[6903,6901],[6901,6856],[6856,6903],[6903,6982],[6982,7028],[7028,6950],[6950,6903]],"Men":[[2175,1865],[1865,1599],[1599,1642]],"Mic":[[7794,7781],[7781,7972],[7972,7954],[7954,7859],[7859,7794]],"Mon":[[2889,3104],[3104,2655],[2655,2324],[2324,2203],[2203,2655],[2655,2472],[2472,2271],[2271,2357],[2357,2419]],"Mus":[[4431,4591],[4591,4717],[4717,4761],[4761,4847],[4847,4690],[4690,4717]],"Nor":[[5889,6017],[6017,5980],[5980,5868],[5868,5889]],"Oct":[[5304,8472],[8472,8092],[8092,5304]],"Oph":[[6599,6522],[6522,6503],[6503,6446],[6446,6199],[6199,6043],[6043,5945],[5945,5973],[5973,6072],[6072,6276],[6276,6199],[6199,6072],[6072,6045],[6045,6016],[6016,6003],[6003,6012],[6012,6503],[6503,6276],[6276,6350],[6350,6397]],"Ori":[[2156,2055],[2055,2123],[2123,2190],[2190,2112],[2112,2065],[2065,1811],[1811,1594],[1594,1617],[1617,1588],[1588,1572],[1572,1563],[1563,1568],[1568,1594],[1594,1607],[1607,1658],[1658,1695],[1695,1724],[1724,1799],[1799,1867],[1867,1811],[1811,1896],[1896,2065],[2065,1955],[1955,2008],[2008,1955],[1955,1912],[1912,1867]],"Pav":[[7624,7755],[7755,7518],[7518,6964],[6964,6757],[6757,6664],[6664,6513],[6513,6887],[6887,7463],[7463,7755],[7755,8010]],"Peg":[[8256,8456],[8456,8578],[8578,50],[50,74],[74,8584],[8584,8476],[8476,8443],[8443,8259],[8259,8118],[8118,8584],[8584,8578],[8578,8496],[8496,8475],[8475,8237],[8237,8122]],"Per":[[1167,1239],[1239,1263],[1263,1257],[1257,1178],[1178,1160],[1160,1129],[1129,1056],[1056,948],[948,874],[874,894],[894,969],[969,971],[971,965],[965,981],[981,949],[949,914],[914,922],[922,965],[965,1293],[1293,1342],[1342,1304],[1304,1160],[1160,969],[969,840],[840,530]],"Phe":[[132,336],[336,449],[449,460],[460,353],[353,336],[336,61],[61,132]],"Pic":[[2473,2018],[2018,2001]],"Psc":[[383,374],[374,404],[404,383],[383,372],[372,461],[461,539],[539,620],[620,575],[575,512],[512,456],[456,382],[382,320],[320,251],[251,8867],[8867,8775],[8775,8718],[8718,8678],[8678,8653],[8653,8709],[8709,8786],[8786,8805],[8805,8775],[8775,8653],[8653,8579]],"PsA":[[8439,8542],[8542,8533],[8533,8508],[8508,8391],[8391,8246],[8246,8124],[8124,8142],[8142,8246],[8246,8439]],"Pup":[[2392,2706],[2706,2841],[2841,2866],[2866,2959],[2959,3015],[3015,3099],[3099,3078],[3078,3115],[3115,2959],[2959,2947],[2947,2911],[2911,2841]],"Pyx":[[3078,3340],[3340,3370],[3370,3421]],"Ret":[[1337,1350],[1350,1261],[1261,1166],[1166,1337]],"Sge":[[7304,7352],[7352,7443],[7443,7312],[7312,7352]],"Sgr":[[6720,6767],[6767,6739],[6739,6793],[6793,6696],[6696,7187],[7187,7195],[7195,7058],[7058,6915],[6915,6793],[6793,7417],[7417,7452],[7452,7422],[7422,7280],[7280,7206],[7206,7138],[7138,6990],[6990,6915],[6915,6739],[6739,6638],[6638,6767],[6767,7058],[7058,7089],[7089,6990],[6990,7071],[7071,7107],[7107,7153],[7153,7180],[7180,7181],[7181,7071],[7071,7016],[7016,6979],[6979,6990]],"Sco":[[5841,5850],[5850,5881],[5881,5850],[5850,5988],[5988,6032],[6032,6063],[6063,6144],[6144,6155],[6155,6174],[6174,6283],[6283,6463],[6463,6519],[6519,6495],[6495,6439]],"Scl":[[305,8819],[8819,8665],[8665,8740]],"Sct":[[6843,6929],[6929,6882],[6882,6799],[6799,6843]],"Ser":[[5761,5736],[5736,5776],[5776,5826],[5826,5761],[5761,5689],[5689,5754],[5754,5785],[5785,5945],[6276,6467],[6467,6599],[6599,6626],[6626,6743],[6743,6997]],"Sex":[[3884,3816],[3816,4016],[4016,4023]],"Tau":[[1929,1490],[1490,1445],[1445,1372],[1372,1398],[1398,1443],[1443,1817],[1817,1372],[1372,1269],[1269,1068],[1068,1277],[1277,1068],[1068,1061],[1061,1132]],"Tel":[[6685,6785],[6785,6798]],"Tri":[[571,659],[659,704],[704,571]],"TrA":[[6137,5813],[5813,5598],[5598,6137]],"Tuc":[[8318,8656],[8656,158],[158,111],[111,8870],[8870,8362],[8362,8318]],"UMa":[[4577,4222],[4222,4212],[4212,4468],[4468,4577],[4577,4810],[4810,4959],[4959,5091],[5091,4468],[4468,4434],[4434,4289],[4289,8887],[8887,4434],[4434,4250],[4250,3974],[3974,4250],[4250,3941],[3941,4222],[4222,3684],[3684,3266],[3266,3801],[3801,4212],[4212,3813],[3813,3700],[3700,3486],[3486,3512],[3512,3700]],"UMi":[[5752,5969],[5969,5607],[5607,5435],[5435,5752],[5752,6126],[6126,6430],[6430,772]],"Vel":[[3378,3631],[3631,3835],[3835,4125],[4125,3925],[3925,3680],[3680,3529],[3529,3115]],"Vir":[[4433,4456],[4456,4604],[4604,4738],[4738,4881],[4881,4966],[4966,5234],[5234,5383],[5383,4846],[4846,4822],[4822,4738],[4738,4881],[4881,5014],[5014,5162],[5162,5405]],"Vol":[[3507,3234],[3234,3101],[3101,2703],[2703,2638],[2638,3101],[3101,3507]],"Vul":[[7143,7227],[7227,7404],[7404,7466],[7466,7558]]};

export const CONSTELLATION_FALLBACK_POINTS: Record<string, readonly { ra: number; dec: number }[]> = {"And":[],"Ant":[],"Aps":[],"Aqr":[],"Aql":[],"Ara":[],"Ari":[],"Aur":[],"Boo":[],"Cae":[],"Cam":[],"Cnc":[],"CVn":[],"CMa":[],"CMi":[],"Cap":[],"Car":[],"Cas":[],"Cen":[],"Cep":[],"Cet":[],"Cha":[],"Cir":[],"Col":[],"Com":[],"CrA":[],"CrB":[],"Crv":[],"Crt":[],"Cru":[],"Cyg":[],"Del":[],"Dor":[],"Dra":[],"Equ":[],"Eri":[],"For":[],"Gem":[],"Gru":[],"Her":[],"Hor":[],"Hya":[],"Hyi":[],"Ind":[],"Lac":[],"Leo":[],"LMi":[],"Lep":[],"Lib":[],"Lup":[],"Lyn":[],"Lyr":[],"Men":[],"Mic":[],"Mon":[],"Mus":[],"Nor":[],"Oct":[],"Oph":[],"Ori":[],"Pav":[],"Peg":[],"Per":[],"Phe":[],"Pic":[],"Psc":[],"PsA":[],"Pup":[],"Pyx":[],"Ret":[],"Sge":[],"Sgr":[],"Sco":[],"Scl":[],"Sct":[],"Ser":[],"Sex":[],"Tau":[],"Tel":[],"Tri":[],"TrA":[],"Tuc":[],"UMa":[],"UMi":[],"Vel":[],"Vir":[],"Vol":[],"Vul":[]};
